import * as React from 'react';
var DEFAULTS = {
    htmlElement: undefined
};
var ReactPortalContext = React.createContext(DEFAULTS);
var ReactPortalProvider = function (_a) {
    var reactPortalContext = _a.reactPortalContext, children = _a.children;
    var htmlElement = reactPortalContext.htmlElement;
    return (React.createElement(ReactPortalContext.Provider, { value: { htmlElement: htmlElement } }, children));
};
var useReactPortal = function () {
    return React.useContext(ReactPortalContext);
};
export { ReactPortalProvider, useReactPortal };
//# sourceMappingURL=portal-context.js.map